export const titleSperator = `<svg width="209" height="2" viewBox="0 0 209 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="2" width="2" height="209" transform="rotate(-90 0 2)" fill="url(#paint0_radial_6843_62396)"/>
<defs>
<radialGradient id="paint0_radial_6843_62396" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1 106.5) rotate(90) scale(104.5 1)">
<stop stop-color="#99F1FF"/>
<stop offset="1" stop-color="#FF53FF" stop-opacity="0"/>
</radialGradient>
</defs>
</svg>`;
